import {
  SearchAutocomplete,
  SearchAutocompleteOption,
} from '@/components/inputs'
import { useResearchTypes } from '@/hooks/api'

type ResearchTypesSelectProps = {
  value?: string
  onChange: (value: string | undefined) => void
  placeholder?: string
}

export const ResearchTypesSelect = ({
  value,
  onChange,
  placeholder,
}: ResearchTypesSelectProps): JSX.Element => {
  const { data: researchTypes } = useResearchTypes({})

  return (
    <SearchAutocomplete
      value={value}
      onChange={onChange}
      options={researchTypes?.map(
        (researchType) =>
          ({
            label: researchType.name,
            value: researchType.id.toString(),
          } as SearchAutocompleteOption)
      )}
      placeholder={placeholder}
      sort={true}
      fieldSx={{ width: 280 }}
    />
  )
}
